<app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="tituloCard" *ngIf="!mostrarFormulario" [optionsExport]="false">
</app-lfsa-card>

<ng-template #enviarTemplate>
  <h2 class="container float-left">{{ tituloForm }}</h2>
  <div class="row form-group">
    <div class="form-group col-md-8">
      <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter "
        (keyup)="onQuickFilterChanged() " #quickFilter />
    </div>
    <div class="form-group col-md-2">
      <button (click)="nuevo()" class={{DAT_BTNCSS.success}}>{{DAT_BTNS.agregar}}</button>
    </div>
    <div class="form-group col-md-2">
      <button (click)="openModal()" class={{DAT_BTNCSS.primary}}>Copiar</button>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <ag-grid-angular class="{{modulo.agGrid.class}}" #agGrid [ngStyle]="modulo.agGrid.style" id="{{modulo.agGrid.id}}"
        [paginationPageSize]="modulo.agGrid.paginacion" [pagination]="true" [frameworkComponents]="frameworkComponents"
        [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </div>
</ng-template>

<app-lfsa-card [innTemplate]="enviarTemplateResport" [titulo]="tituloForm" *ngIf="mostrarFormulario">
</app-lfsa-card>
<ng-template #enviarTemplateResport>
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="row">
        <div class="form-group col-12 col-md-6">
          <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Año'" [label]="'Año *'"
            [id]="'periodo'" formControlName="periodo" [control]="formulario.get('periodo')"></app-lfsa-input>
        </div>
        <div class="form-group col-12 col-md-6">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbSiNo"
            formControlName="predeterminado" [control]="formulario.get('predeterminado')" [label]="'Predeterminado *'"
            [id]="'predeterminado'">
          </app-lfsa-combo-box>
        </div>
      </div>
    </div>
    <hr>
    <div [formGroup]="formularioPeriodo" novalidate class="form-group">
      <div class="row">
        <div class="form-group col-12 col-md-6">
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
                [comboBox]="cmbMeses" formControlName="mes" [control]="formularioPeriodo.get('mes')" [label]="'Mes *'"
                [id]="'mes'">
              </app-lfsa-combo-box>
            </div>
            <div class="form-group col-12 col-md-6">
              <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Días'"
                [label]="'Días *'" [id]="'dias'" formControlName="dias"
                [control]="formularioPeriodo.get('dias')"></app-lfsa-input>
            </div>
            <div class="form-group col-12 col-md-12">
              <button (click)="guardarPeriodo()" class={{DAT_BTNCSS.success}}
                [disabled]="formularioPeriodo.invalid">Agregar Mes</button>
            </div>
          </div>
        </div>
        <div class="form-group col-12 col-md-6">
          <div class="row">
            <table class="table table-bordered table-hover" style="width: 100%;">
              <thead>
                <tr>
                  <th></th>
                  <th>Periodo</th>
                  <th>Mes</th>
                  <th>Días</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let periodo of calendarioPeriodos; index as i">
                  <td align="center">{{i+1}}</td>
                  <td>{{ formulario.get('periodo').value }}</td>
                  <td>{{periodo.mesDescripcion}}</td>
                  <td>{{periodo.dias}}</td>
                  <td>
                    <button (click)="eliminarPeriodo(periodo)" class={{DAT_BTNCSS.danger}}>X</button>
                  </td>
                </tr>
              </tbody>
              <tfoot *ngIf="calendarioPeriodos.length <= 0">
                <tr>
                  <th colspan="5" align="center">
                    Sin resultados
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="form-group col-12">
        <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones($event)"
          [textBoton]="textBoton"></app-lfsa-botones-formulario>
      </div>
    </div>
  </div>
</ng-template>

<app-lfsa-modal [innTemplate]="enviarModal" [titulo]="'Editar Calendario'" [idButton]="'buttonAbrirModal'"
  [idOpen]="'abrirModal'" [idClose]="'cerrarModal'"></app-lfsa-modal>
<ng-template #enviarModal>
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="row">
        <div class="form-group col-12 col-md-3">
          <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'" [placeholder]="'ID'"
            [label]="'ID *'" [id]="'idCalendario'" formControlName="idCalendario"
            [control]="formulario.get('idCalendario')"></app-lfsa-input>
        </div>
        <div class="form-group col-12 col-md-3">
          <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Año'" [label]="'Año *'"
            [id]="'periodo'" formControlName="periodo" [control]="formulario.get('periodo')"></app-lfsa-input>
        </div>
        <div class="form-group col-12 col-md-3">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbSiNo"
            formControlName="predeterminado" [control]="formulario.get('predeterminado')" [label]="'Predeterminado *'"
            [id]="'predeterminado'">
          </app-lfsa-combo-box>
        </div>
        <div class="form-group col-12 col-md-3" style="display: flex;
        align-items: center;">
          <button (click)="eliminarCalendario()" class={{DAT_BTNCSS.danger}}>Eliminar calendario</button>
        </div>
      </div>
    </div>
    <hr>
    <div [formGroup]="formularioPeriodo" novalidate class="form-group">
      <div class="row">
        <div class="form-group col-12 col-md-6">
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'"
                [comboBox]="cmbMeses" formControlName="mes" [control]="formularioPeriodo.get('mes')" [label]="'Mes *'"
                [id]="'mes'">
              </app-lfsa-combo-box>
            </div>
            <div class="form-group col-12 col-md-6">
              <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Días'"
                [label]="'Días *'" [id]="'dias'" formControlName="dias"
                [control]="formularioPeriodo.get('dias')"></app-lfsa-input>
            </div>
            <div class="form-group col-12 col-md-12">
              <button (click)="guardarPeriodo()" class={{DAT_BTNCSS.success}}
                [disabled]="formularioPeriodo.invalid">Agregar Mes</button>
            </div>
          </div>
        </div>
        <div class="form-group col-12 col-md-6">
          <div class="row">
            <table class="table table-bordered table-hover" style="width: 100%;">
              <thead>
                <tr>
                  <th></th>
                  <th>Periodo</th>
                  <th>Mes</th>
                  <th>Días</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let periodo of calendarioPeriodos; index as i">
                  <td align="center">{{i+1}}</td>
                  <td>{{ formulario.get('periodo').value }}</td>
                  <td>{{periodo.mesDescripcion}}</td>
                  <td align="center">{{periodo.dias}}</td>
                  <td>
                    <button (click)="eliminarPeriodo(periodo)" class={{DAT_BTNCSS.danger}}>X</button>
                  </td>
                </tr>
              </tbody>
              <tfoot *ngIf="calendarioPeriodos.length <= 0">
                <tr>
                  <th colspan="5" align="center">
                    Sin resultados
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="form-group col-12">
        <app-lfsa-botones-formulario [formularioValido]="formulario.invalid"
          (devolverAccion)="accionesActualizar($event)" [textBoton]="textBoton"></app-lfsa-botones-formulario>
      </div>
    </div>
  </div>
</ng-template>


<app-lfsa-modal [classModal]="'modal-md'" [idButton]="'fillOne'" [idOpen]="'Modal'" [idClose]="'cerrarModalPeso'"
  [innTemplate]="abrirModalPeso" [titulo]="'COPIAR CALENDARIO'"></app-lfsa-modal>
<ng-template #abrirModalPeso>
  <div class="container-fluid">
    <div class="row">
      <div [formGroup]="duplicarCalendario" novalidate class="form-group">
        <div class="form-group col-12 col-md-6">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descDuplicar'" [idOpcion]="'idCalendario'"
            [comboBox]="rowData" formControlName="duplicar" [control]="duplicarCalendario.get('duplicar')"
            [label]="'Calendario *'" [id]="'duplicar'">
          </app-lfsa-combo-box>
        </div>
        <div class="form-group col-12 col-md-12">
          <button (click)="duplicar()" class={{DAT_BTNCSS.success}}
            [disabled]="duplicarCalendario.invalid">
            Duplicar
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>